import { render, staticRenderFns } from "./ParallaxBanner.vue?vue&type=template&id=67f7347c&scoped=true&"
import script from "./ParallaxBanner.vue?vue&type=script&lang=js&"
export * from "./ParallaxBanner.vue?vue&type=script&lang=js&"
import style0 from "./ParallaxBanner.vue?vue&type=style&index=0&id=67f7347c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7347c",
  null
  
)

export default component.exports